module.exports = __webpack_public_path__ + "static/media/11.05dd3821.jpg";